import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import NotificationDropdown from '../notifications/NotificationDropdown';
import MessageBadge from '../chat/MessageBadge';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.5rem;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 992px) {
    display: none;
  }
`;

const Logo = styled(Link)`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
`;

const UserName = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.danger};
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Header = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };
  
  // Get user initials for avatar
  const getInitials = () => {
    if (!currentUser || !currentUser.displayName) return '?';
    
    const nameParts = currentUser.displayName.split(' ');
    if (nameParts.length === 1) return nameParts[0].charAt(0).toUpperCase();
    
    return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
  };
  
  const isPartner = currentUser?.role === 'partner';
  
  return (
    <HeaderContainer>
      <Logo to="/">Geo Diet Wonder</Logo>
      
      {currentUser && (
        <RightSection>
          <NotificationDropdown />
          
          {/* Show message badge for partners */}
          {isPartner && (
            <MessageBadge redirectPath="/partner/messages" />
          )}
          
          <UserInfo>
            <Avatar>{getInitials()}</Avatar>
            <UserName>{currentUser.displayName || currentUser.email}</UserName>
          </UserInfo>
          
          <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
        </RightSection>
      )}
    </HeaderContainer>
  );
};

export default Header; 